var Module = {
    name: 'modalUserExist',
    selectors: {
        modalButton: '.contactModalButton',
        modal: '#resign_popup',
        form: '#subscriptionContactForm',
    },

    init: function () {
        Module.onModalSubmit();
    },

    onModalSubmit: function () {
        $(document).on('click', Module.selectors.modalButton, function (e) {
            $(document).find(Module.selectors.modalButton).prop('disabled', 'disabled');

            let userEmail = $(Module.selectors.form).find('[name="email"]').val();
            if (!userEmail) {
                userEmail = $(Module.selectors.modalButton).data('email');
            }

            var action = $(this).data('action');
            switch (action) {
                case 'new_order':
                    $(Module.selectors.form).trigger('submit');
                    return false;
                case 'has_active_minibox_new_order':
                    $(Module.selectors.form).append('<input name="force" value="1" hidden>');
                    $(Module.selectors.form).trigger('submit');
                    return false;
                case 'login_for_update':
                    Module.checkAndRedirectLoginForUpdate();
                    return false;
                case 'login_for_update_close_order':
                    Module.closeOrder();
                    Module.checkAndRedirectLoginForUpdate();
                    return false;
                case 'login_close_order':
                    Module.closeOrder();
                    break;
                case 'login':
            }
        });
    },

    closeOrder: function () {
        let closeOrderToken = $(Module.selectors.modal).data('close-order');
        let closeOrderUrl = $(Module.selectors.modal).data('close-order-url');

        if (closeOrderToken && closeOrderUrl) {
            $.ajax({
                type: 'POST',
                url: closeOrderUrl,
                async: false,
                headers: { 'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content') },
                data: { token: closeOrderToken }
            });
        } 
    },

    checkAndRedirectLoginForUpdate: function () {
        $.ajax({
            type: 'POST',
            url: $(this).data('url'),
            data: { email: userEmail }
        }).done(function (response) {
            window.location = response.url;
        }).fail(function (response) {
            if (parseInt(response.status) === 419) {
                ErrorHandlerModule.processTokenMismatch();
            }
        });
    },
}

module.exports = Module
